import { Star, Navigation, Car, Clock } from 'lucide-react';
import type { City } from '@/data/cities';

interface Props { city: City }

const VilleStats = ({ city }: Props) => {
  const icons = [Star, Navigation, Car, Clock];

  return (
    <section className="py-12 px-6 lg:px-8 bg-background">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {city.stats.map((s, i) => {
            const Icon = icons[i % icons.length];
            return (
              <div key={i} className="text-center p-6 rounded-2xl border border-border bg-card">
                <div className="w-11 h-11 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
                  <Icon size={20} className="text-primary" strokeWidth={1.5} />
                </div>
                <p className="font-heading text-2xl md:text-3xl font-black text-foreground">{s.value}</p>
                <p className="text-xs text-muted-foreground mt-1">{s.label}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default VilleStats;
